import { createConsumer } from '@rails/actioncable'

const actionCable = createConsumer('/cable')

export default actionCable
